import React from 'react';
import PasswordGate from './PasswordGate.jsx';
import WatchPlayer from './WatchPlayer.jsx';

export default function Watch({ onExit, tweaks, urlParams = {} }) {
  return (
    <PasswordGate
      role="watch"
      onExit={onExit}
      urlParams={urlParams}
      hint="hint: he nailed it"
    >
      <WatchPlayer onExit={onExit} tweaks={tweaks} />
    </PasswordGate>
  );
}
